/* Счета бизнеса: где лежат его деньги. Отдельной сущности у счёта нет —
   он заводится и правится прямо в карточке бизнеса, поэтому строка редактируется
   на месте: название и остаток. Нала и безнала нет — счёт и есть кошелёк. */

import { rub } from "@mera/shared";
import { List, ListItem } from "konsta/react";
import React from "react";

import { Ion } from "./icons.jsx";
import { haptic } from "../lib/tg.js";

export default function AccountsEditor({ accounts, onChange }) {
  const rows = accounts || [];
  const total = rows.reduce((s, r) => s + (Number(r.balance) || 0), 0);

  const patch = (i, key) => (e) =>
    onChange(rows.map((r, n) => (n === i ? { ...r, [key]: e.target.value } : r)));
  const remove = (i) => () => { haptic.light(); onChange(rows.filter((_, n) => n !== i)); };
  const add = () => { haptic.light(); onChange([...rows, { name: "", balance: "" }]); };

  return (
    <div className="mt-8">
      <div className="px-8 pb-1 text-[13px]" style={{ color: "var(--tg-hint)" }}>
        Счета бизнеса
      </div>
      <List strong inset className="!my-0">
        {rows.map((r, i) => (
          <li key={r.id || `new-${i}`} className="hairline-b">
            <div className="flex items-center gap-2 ps-4 pe-3 py-2.5">
              <input
                className="min-w-0 flex-1 bg-transparent outline-none text-[15px]"
                style={{ color: "var(--tg-text)" }}
                type="text"
                placeholder="Название · Тинькофф, наличные"
                value={r.name}
                onChange={patch(i, "name")}
              />
              <input
                className="num w-28 shrink-0 bg-transparent outline-none text-[17px] text-right"
                style={{ color: "var(--tg-text)" }}
                type="number"
                inputMode="decimal"
                placeholder="0 ₽"
                value={r.balance}
                onChange={patch(i, "balance")}
              />
              <button
                type="button"
                onClick={remove(i)}
                aria-label="Убрать счёт"
                className="shrink-0 w-7 h-7 inline-flex items-center justify-center active:opacity-50"
              >
                <Ion.close size={18} style={{ color: "var(--fin-red)" }} />
              </button>
            </div>
          </li>
        ))}
        <ListItem
          link
          chevron={false}
          colors={{ primaryTextIos: "text-[color:var(--tg-link)]" }}
          media={<Ion.add size={20} style={{ color: "var(--tg-link)" }} />}
          title="Добавить счёт"
          onClick={add}
        />
      </List>

      <div className="px-8 pt-1.5 text-[13px]" style={{ color: "var(--tg-hint)" }}>
        {rows.length
          ? <>Всего на счетах — <span className="num">{rub(total)}</span>. Первый счёт основной: на него ложатся оплаты.</>
          : <>Без счёта операцию по бизнесу записать некуда.</>}
      </div>
    </div>
  );
}
